import { render, staticRenderFns } from "./AccountantsLedgerMenu.vue?vue&type=template&id=fa178d2e&scoped=true&"
import script from "./AccountantsLedgerMenu.vue?vue&type=script&lang=js&"
export * from "./AccountantsLedgerMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa178d2e",
  null
  
)

export default component.exports